export { ThemeProvider } from "./theme-provider";
export type { ThemeProviderProps } from "./theme-provider";